<script setup lang="tsx">
import * as Chartist from 'chartist'
import { ref, onMounted } from 'vue'
import { drawLines } from '@/components/donut'

const props = defineProps<{
	label: string
	link: string
	implemented: number
	partiallyImplemented: number
	conditionallyImplemented: number
	notCompleted: number
	willNotApply: number
	willNotImplement: number
	needsAttention: number
}>()

const chart = ref(null)

const opts: Chartist.PieChartOptions = {
	donut: true,
	donutWidth: 40,
	startAngle: 45,
	showLabel: true,
	labelInterpolationFnc: (a) => (a ? a + '%' : null),
}

let pieChart: Chartist.PieChart

onMounted(() => {
	pieChart = new Chartist.PieChart(
		chart.value,
		{
			series: [
				{ className: 'pie1', value: props.implemented },
				{ className: 'pie-ci', value: props.conditionallyImplemented },
				{ className: 'pie2', value: props.partiallyImplemented },
				{ className: 'pie3', value: props.notCompleted },
				{ className: 'pie4', value: props.willNotApply },
				{ className: 'pie6', value: props.needsAttention },
				{ className: 'pie-wni', value: props.willNotImplement },
			],
		},
		opts,
	)
	drawLines(pieChart)
})
</script>

<template>
	<div class="d-flex justify-content-center align-items-center position-relative">
		<div ref="chart" class="chart"></div>
		<div class="label position-absolute">
			<h6 class="chart-content">
				<a v-if="props.link" :href="props.link">{{ props.label }}</a>
				<template v-else>{{ props.label }}</template>
			</h6>
		</div>
	</div>
</template>

<style lang="sass" scoped>
.chart
  height: 300px
  padding: 1.2em

.label
  width: 50%
  overflow: hidden
  text-overflow: ellipsis
  text-align: center
</style>
